import { useRumService } from '@servicetitan/datadog-rum';
import { useEffect } from 'react';
import type { EntryPoint, RequestOrigin, SourceMfe } from '@servicetitan/financing-api-client';

export interface UseRequestAttributionRumParams {
    rumServiceName: string;
    origin?: RequestOrigin;
    entryPoint?: EntryPoint;
    sourceMfe?: SourceMfe;
}

export function useRequestAttributionRum({
    rumServiceName,
    origin,
    entryPoint,
    sourceMfe,
}: UseRequestAttributionRumParams) {
    const { setServiceContext } = useRumService({ name: rumServiceName });

    useEffect(() => {
        const attribution = { origin, entryPoint, sourceMfe };

        setServiceContext(attribution);
        window.DD_RUM?.setGlobalContextProperty?.('financingAttribution', attribution);
    }, [setServiceContext, origin, entryPoint, sourceMfe]);
}
